import auth from "./auth";
import api from "./api";

const BASE_SERVICE_URL = "estore-service";

export default {
  getCategories() {
    return new Promise((resolve, reject) => {
      api.get(
        `${BASE_SERVICE_URL}/v1/cms/estore/category/list`,
        auth.getHeader()
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
